import { createAction } from '@reduxjs/toolkit';
import type { PriceChange } from '../../types/order';
import * as ORDER from '../constants/order';

// Flights actions:
export const skipFlightsAction = () => ({
  type: ORDER.SKIP_FLIGHTS,
});
export const selectFlight = (payload) => ({
  type: ORDER.SELECT_FLIGHT,
  payload,
});
export const setFlightInfoAction = (payload) => ({
  type: ORDER.SET_FLIGHT_INFO,
  payload,
});

// Tourist actions:
export const changeTourist = (payload) => ({
  type: ORDER.CHANGE_TOURIST,
  payload,
});
export const submitTourists = () => ({
  type: ORDER.SUBMIT_TOURISTS,
});

export const submitTouristSimpleHotelCheckout = () => ({
  type: ORDER.SUBMIT_TOURIST_SIMPLE_CHECKOUT,
});

// Prebuild actions:
export const prebuildOrderAction = (payload?: unknown) => ({
  type: ORDER.PREBUILD_ORDER,
  payload,
});
export const prebuildOrderSuccess = (payload) => ({
  type: ORDER.PREBUILD_ORDER_SUCCESS,
  payload,
});
export const prebuildOrderCompleteWithMindboxErrors = (payload) => ({
  type: ORDER.PREBUILD_ORDER_COMPLETE_WITH_MINDBOX_ERRORS,
  payload,
});
export const prebuildOrderFail = (payload) => ({
  type: ORDER.PREBUILD_ORDER_FAIL,
  payload,
});

// Create order actions:
export const createOrderAction = () => ({
  type: ORDER.CREATE_ORDER,
});
export const createOrderSuccess = (payload) => ({
  type: ORDER.CREATE_ORDER_SUCCESS,
  payload,
});
export const createOrderFail = (payload) => ({
  type: ORDER.CREATE_ORDER_FAIL,
  payload,
});
export const confirmClientAction = (payload) => ({
  type: ORDER.CONFIRM_CLIENT,
  payload,
});
export const resetClientAction = () => ({
  type: ORDER.RESET_CLIENT,
});

// Addinitional actions:
export const toggleInsuranceAction = (payload: {
  hashsum: string;
  selected: boolean;
}) => ({
  type: ORDER.TOGGLE_INSURANCE,
  payload,
});
export const changeOrderCommentAction = (payload) => ({
  type: ORDER.CHANGE_ORDER_COMMENT,
  payload,
});

// Check actions:
export const stashUserPriceBeforePayAction = (payload) => ({
  type: ORDER.STASH_USER_PRICE_BEFORE_PAY,
  payload,
});

// Extras actions:
export const addExtraAction = (payload) => ({
  type: ORDER.ADD_EXTRA,
  payload,
});
export const removeExtraAction = (payload) => ({
  type: ORDER.REMOVE_EXTRA,
  payload,
});
export const toggleExtraAction = (payload) => ({
  type: ORDER.TOGGLE_EXTRA,
  payload,
});

// Order actions:
export const orderProcessedAction = () => ({
  type: ORDER.ORDER_PROCESSED,
});
export const finishOrderAction = () => ({
  type: ORDER.FINISH_ORDER,
});
export const goToOrderPageAction = () => ({
  type: ORDER.GO_TO_ORDER_PAGE,
});
export const confirmOrderAction = () => ({
  type: ORDER.CONFIRM_ORDER,
});

// Update order actions:
export const updateOrderAction = () => ({
  type: ORDER.UPDATE_ORDER,
});
export const updateOrderSuccessAction = (payload) => ({
  type: ORDER.UPDATE_ORDER_SUCCESS,
  payload,
});
export const updateOrderFailedAction = () => ({
  type: ORDER.UPDATE_ORDER_FAIL,
});

// Package actions:
export const submitPackageAction = () => ({
  type: ORDER.SUBMIT_PACKAGE,
});

// Sub payments:
export const addCouponAction = (payload) => ({
  type: ORDER.ADD_COUPON,
  payload,
});
export const addBonusAction = (payload) => ({
  type: ORDER.ADD_BONUS,
  payload,
});
export const setPaylateDataAction = (payload) => ({
  type: ORDER.SET_PAYLATE_DATA,
  payload,
});
export const payByDiscountAction = () => ({
  type: ORDER.PAY_BY_DISCOUNT,
});
export const checkPriceReductionByCashbackAction = () => ({
  type: ORDER.CHECK_PRICE_REDUCTION_BY_CASHBACK,
});

// Price change
export const setPriceChangeAction = createAction<{ priceChange: PriceChange }>(
  ORDER.SET_PRICE_CHANGE,
);

/**
 * Добавление в стор общего числа заказов,
 * если выбраны совместные заказы
 */
export const setOrdersAmountAction = createAction<number>(
  ORDER.SET_ORDERS_AMOUNT,
);
/**
 * Добавление в стор номера первого заказа,
 * если выбраны совместные заказы
 */
export const setFirstOrderNumberAction = createAction<number>(
  ORDER.SET_FIRST_ORDER_NUMBER,
);
/**
 * Изменение заказа с дополнительного на первый
 * либо наоборот, если выбраны совместные заказаы
 */
export const switchOrderAction = createAction(ORDER.SWITCH_ORDER);

/**
 * Если выбраны совместные заказы по умолчанию грузится первый заказ
 */
export const setFirstOrderFieldAction = createAction<boolean | null>(
  ORDER.SET_FIRST_ORDER_FIELD,
);
